import { VERS } from "./endPoints";

/**
 * Local Storage Keys
 * ------------------------------------------------------------
 * Centralized keys used to store and retrieve data
 * from browser localStorage.
 *
 * Usage ensures consistency and prevents typos across the app.
 */
export const LOCAL_STORAGE_KEY = {
  /** Authentication token for logged-in user */
  AUTH_TOKEN: "__XuserToken",

  /** User information object */
  USER_INFO: "__XuserInfo",
};

/**
 * User-Facing Messages
 * ------------------------------------------------------------
 * Centralized message constants used across the app for:
 * - Error handling
 * - Validation failures
 * - Success confirmations
 *
 * Benefits:
 * - Ensures consistency across UI
 * - Simplifies maintenance and localization
 */
export const initAlertMsg = {
  open: false,
  label: "",
  msg: "",
  isError: false,
  isLoading: false,
  btnText: "",
  canClose: false,
};

export const SHOW_MESSAGE = {
  // ---------------- General Errors ----------------
  SOMETHING_WENT_WRONG: "Something went wrong. Please try again.",
  VALIDATION_FAILED: "Validation failed.",

  // ---------------- Auth / Forgot Password ----------------
  FORGOT_PASSWORD_FAILED: "Failed to reset password.",
  LOGIN_FAILED: "Login failed.",

  // ---------------- Reset Password ----------------
  RESET_PASSWORD_SUCCESS_MSG:
    "Your password has been reset successfully. You can now log in with your new password.",
  RESET_PASSWORD_SUCCESS_HEADING: "Password Reset Successful",
  RESET_PASSWORD_FAILED: "Failed to reset password.",

  // ---------------- Change Password ----------------
  CHANGE_PASSWORD_SUCCESS_MSG: "Your password has been updated.",
  CHANGE_PASSWORD_SUCCESS_HEADING: "Password Change Successful",
  CHANGE_PASSWORD_FAILED: "Failed to change password.",

  // ---------------- Add / Update Profile Photo ----------------
  UPDATE_PROFILE_PHOTO_SUCCESS_HEADING: "Profile Photo Uploaded Successfully",
  UPDATE_PROFILE_PHOTO_SUCCESS_MSG: "The profile photo has been uploaded.",
  UPDATE_PROFILE_PHOTO_FAILED: "Failed to upload profile photo.",

  // ---------------- Remove Profile Photo ----------------
  REMOVE_PROFILE_PHOTO_SUCCESS_HEADING: "Profile Photo Removed Successfully",
  REMOVE_PROFILE_PHOTO_SUCCESS_MSG: "The profile photo has been removed.",
  REMOVE_PROFILE_PHOTO_FAILED: "Failed to remove profile photo.",

  // ---------------- Publish Simulation Configuration ----------------
  PUBLISH_SIMULATION_CONFIGURATION_FAILED_HEADING:
    "Publish Simulation Configuration Failed",

  // ---------------- Update Simulation Configuration ----------------
  UPDATE_SIMULATION_CONFIGURATION_FAILED_HEADING:
    "Update Simulation Configuration Failed",

  // ---------------- Save Simulation Configuration ----------------
  CREATE_SIMULATION_CONFIGURATION_FAILED_HEADING:
    "Create Simulation Configuration Failed",

  // ---------------- Publish Experience ----------------
  PUBLISH_EXPERIENCE_FAILED_HEADING: "Publish Experience Failed",

  DUPLICATE_EXPERIENCE_NAME_MSG:"Duplicate Experience Name",
};
